import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import {
  Button,
  Divider,
  Grid,
  Header,
  Image,
  Segment,
} from 'semantic-ui-react';
import { FileUploadInterface } from '../../../../app/models/Profile';
import { useStore } from '../../../../app/stores/store';

function HistoryAttachment() {
  const { activityStore, modalStore } = useStore();
  const { historyAttachmentFiles } = activityStore;
  const [fileData, setFileData] = useState<FileUploadInterface[]>([]);

  useEffect(() => {
    setFileData(historyAttachmentFiles);
  }, [historyAttachmentFiles]);

  return (
    <div>
      <Header>Attachments</Header>
      <Segment style={{ height: '300px', overflowY: 'scroll' }}>
        <Grid>
          {fileData?.map((x) => {
            return (
              <Grid.Column textAlign={'center'} key={x.id} width={8}>
                <Image key={x?.id} src={x?.url} alt={x?.url} />
              </Grid.Column>
            );
          })}
        </Grid>
      </Segment>
      <Divider />
      <Button
        style={{ marginBottom: '20px' }}
        color="black"
        floated="right"
        onClick={() => modalStore.closeSmallModal()}
      >
        Close
      </Button>
    </div>
  );
}

export default observer(HistoryAttachment);
